import { render, staticRenderFns } from "./TailwindAccordionCard.vue?vue&type=template&id=2ef16b24&"
import script from "./TailwindAccordionCard.vue?vue&type=script&lang=ts&"
export * from "./TailwindAccordionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports